new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0)
  },
  methods: {
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#FF4405', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#FF4405', controlSlider);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#FF4405', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#FF4405', toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const fromInput = document.querySelector('#fromInput');
      const toInput = document.querySelector('#toInput');
      let url = window.location.href;

      if (url.includes('?lp=')) {
        const params = new URLSearchParams(window.location.search)
        const firstParams = params.get('lp');
        const secondParams = params.get('hp');
        fromInput.value = firstParams;
        toInput.value = secondParams;
        fromSlider.setAttribute('value', firstParams);
        toSlider.setAttribute('value', secondParams);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#FF4405', toSlider);
      } else {
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#FF4405', toSlider);
        setToggleAccessible(toSlider);
      }

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

      function handleSliderRelease() {
        let from = $('#fromInput').val();
        let to = $('#toInput').val();
        window.location = `?lp=${from}&hp=${to}`;
      }

      $(fromSlider).mouseup(handleSliderRelease);
      $(fromSlider).on('touchend', handleSliderRelease);

      $(toSlider).mouseup(handleSliderRelease);
      $(toSlider).on('touchend', handleSliderRelease);
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    this.filterPrice();

    const filterSize = document.querySelectorAll(".product-filter__item--size:not(.product-filter__item--color)");
    const elementDest = document.querySelector("#buy-sizes");
    if (filterSize.length > 0 && elementDest) {
      // o filtro sidebar renderiza o menu duas vezes: não repetir o mesmo tamanho
      const addedSizes = new Set();
      filterSize.forEach(size => {
        const allSizes = size.querySelectorAll(".product-filter__sub-item");
        if (allSizes.length > 0) {
          allSizes.forEach(subSize => {
            const link = subSize.querySelector(".product-filter__link");
            const key = link ? link.getAttribute("href") : subSize.textContent.trim();
            if (addedSizes.has(key)) return;
            addedSizes.add(key);
            const cloneSubSize = subSize.cloneNode(true);
            elementDest.appendChild(cloneSubSize);
          });
        }
      });
    }

    var selectOrdenar = document.querySelector('.selectskin')
    if (selectOrdenar) {
      var primeiroOption = selectOrdenar.querySelector('option:first-child')
      if (primeiroOption && primeiroOption.textContent.includes("Ordenar por")) {
        primeiroOption.textContent = primeiroOption.textContent.replace("Ordenar por", "Ordenar")
      }
    }

    const categoryFilter = document.querySelector('.product-filter--category');

    if (categoryFilter && !categoryFilter.querySelector(':scope > .product-filter__title')) {
      const categoryTitle = document.createElement('div');

      categoryTitle.className = 'product-filter__title active';
      categoryTitle.textContent = 'Categoria';

      categoryFilter.prepend(categoryTitle);
      categoryFilter.classList.add('has-accordion-title');
    }

    const accordions = [
      ...document.querySelectorAll(
        '.product-filter__item:has(> .product-filter__sub-menu)'
      ),
      ...document.querySelectorAll(
        '.product-filter--price, .product-filter--category'
      )
    ];

    accordions.forEach(function (accordion) {
      const title =
        accordion.querySelector(':scope > .product-filter__item__title') ||
        accordion.querySelector(':scope > .product-filter__title');

      const content =
        accordion.querySelector(':scope > .product-filter__sub-menu') ||
        accordion.querySelector(':scope > .product-filter__menu');

      if (!title || !content) return;

      accordion.classList.add('active');
      content.style.maxHeight = content.scrollHeight + 'px';

      title.addEventListener('click', function (event) {
        event.preventDefault();

        accordion.classList.toggle('active');

        content.style.maxHeight = accordion.classList.contains('active')
          ? content.scrollHeight + 'px'
          : '0';
      });
    });

    // Abrir o primeiro filtro por padrão
    const firstFilterItem = document.querySelector('.product-filter__item');
    if (firstFilterItem) {
      firstFilterItem.classList.add('active');
      const firstSubmenu = firstFilterItem.querySelector('.product-filter__sub-menu');
      if (firstSubmenu) {
        firstSubmenu.style.maxHeight = firstSubmenu.scrollHeight + 'px';
      }
    }
  },
});